import React from 'react';
import { TableHead, TableRow, TableCell } from '@mui/material';

const ReportsTableHeader = ({ headers }) => {

    return (
        <TableHead>
            <TableRow>
                {headers.map((header, index) => (
                    <TableCell key={index} sx={{ fontWeight: 700, color: '#3333CFCE', backgroundColor: '#bcbcef' }}>
                        {header.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default ReportsTableHeader;
